/**
 * Name of the route parameter carrying the client registration invite code.
 */
export const inviteCodePathParam = 'inviteCode';

/**
 * Name of the route parameter carrying the client profile ID.
 */
export const profileIdPathParam = 'profileId';
